<section id="pricing" class="pricing-section">
  <div class="container">
    <div class="pricing-header text-center" appAnimateOnScroll="fade-in-up">
      <h2 class="section-title">{{ 'pricing.TITLE' | translate }}</h2>
      <p class="section-subtitle">{{ 'pricing.SUBTITLE' | translate }}</p>
    </div>
    <div class="row justify-content-center">
      @for (plan of plans; track plan; let i = $index) {
        <div class="col-lg-4 col-md-6 mb-4" appAnimateOnScroll="fade-in-up" [style.transition-delay.ms]="i * 150">
          <div class="pricing-card" [ngClass]="{ 'popular': plan.isPopular }">
            @if (plan.isPopular) {
              <div class="popular-badge">{{ 'pricing.POPULAR_BADGE' | translate }}</div>
            }
            <div class="card-header">
              <h3 class="plan-name">{{ 'pricing.plans.' + plan.key + '.NAME' | translate }}</h3>
              <div class="plan-price">
                <span class="price">{{ 'pricing.plans.' + plan.key + '.PRICE' | translate }}</span>
                <span class="period">{{ 'pricing.PERIOD' | translate }}</span>
              </div>
            </div>
            <div class="card-body">
              <p class="plan-description">{{ 'pricing.plans.' + plan.key + '.DESCRIPTION' | translate }}</p>
              <ul class="features-list">
                @for (feature of ('pricing.plans.' + plan.key + '.FEATURES' | translate); track feature) {
                  <li>
                    <img src="assets/images/check-circle.svg" alt="Check" class="check-icon">
                    <span>{{ feature }}</span>
                  </li>
                }
              </ul>
            </div>
            <div class="card-footer">
              <a href="#contact" class="btn" [ngClass]="plan.buttonClass">{{ 'pricing.BUTTON_TEXT' | translate }}</a>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</section>